export default __webpack_public_path__ + "static/SUPPORTS FOR LANGUAGE LEARNING 2_v2-c0e1fc2b812e903886c90a273b77accb.png";